import { render, staticRenderFns } from "./SocialUploadForm.vue?vue&type=template&id=3e9a9c9f"
import script from "./SocialUploadForm.vue?vue&type=script&lang=js"
export * from "./SocialUploadForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports